import {
  OPEN_BASIC_INFO_MODAL,
  OPEN_DEDUCTIBLE_MODAL,
  OPEN_RATES_MODAL,
  OPEN_RX_MODAL,
  OPEN_SERVICE_MODAL,
  OPEN_CUSTOM_ROW_MODAL,
  OPEN_FREQUENCIES_MODAL,
} from 'modules/clients/UPClient/UPClientConst';

const meta = {
  benguideMetaData: {
    planFieldGroupings: [
      {
        planType: 'medical',
        hotspots: [
          {
            elements: [
              {
                fieldName: 'title',
                fieldValue: 'Plan Name',
                fieldQueries: ['$.name'],
              },
            ],
            event: OPEN_BASIC_INFO_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'monthlyCost',
                fieldValue: 'Your Monthly Cost',
                fieldFormatter: 'contributionFormatter',
                defaultValue: '',
              },
              {
                fieldName: 'planNetwork',
                fieldValue: 'Plan Network',
                fieldFormatter: '',
                defaultValue: '',
              },
            ],
            event: OPEN_RATES_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'customFields',
                fieldValue: '+ Manage Custom Row',
                fieldFormatter: '',
                defaultValue: '',
                customHeader: true,
              },
              {
                fieldName: 'spaceField',
                type: 'space',
                isCustomField: true,
              },
            ],
            isSeparateRowEvent: true,
            event: OPEN_CUSTOM_ROW_MODAL,
          },

          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'DEDUCTIBLES & OOP MAXIMUM',
              },
              {
                fieldName: 'deductibleCost',
                fieldSpecialization: 'individual',
                fieldValue: 'MEDICAL_DEDUCTIBLE_Individual Deductible',
                fieldDescription:
                  'Generally, this is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses. Note that preventive care is typically covered 100% by insurance regardless of where you stand with your deductible.',
              },
              {
                fieldName: 'deductibleCost',
                fieldValue: 'MEDICAL_DEDUCTIBLE_Family Deductible',
                fieldSpecialization: 'family',
                fieldDescription:
                  'Generally, this is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses. Note that preventive care is typically covered 100% by insurance regardless of where you stand with your deductible.',
              },
              {
                fieldName: 'indWithinFamilyDeductible',
                fieldValue: 'MEDICAL_DEDUCTIBLE_Deductible (Ind within Fam)',
                fieldDescription:
                  'Generally, this is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses. Note that preventive care is typically covered 100% by insurance regardless of where you stand with your deductible.',
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'outOfPocketMax',
                fieldValue: 'MEDICAL_DEDUCTIBLE_Individual Out-of-Pocket Max',
                fieldSpecialization: 'individual',
                fieldDescription:
                  'The most you have to pay for covered services and prescriptions in a plan year.',
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'outOfPocketMax',
                fieldValue: 'MEDICAL_DEDUCTIBLE_Family Out-of-Pocket Max',
                fieldSpecialization: 'family',
                fieldDescription:
                  'The most you have to pay for covered services and prescriptions in a plan year.',
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'indWithinFamilyOOPMax',
                fieldValue:
                  'MEDICAL_DEDUCTIBLE_Out-of-Pocket Max (Ind within Fam)',
                fieldSpecialization: 'individual',
                fieldDescription: `The maximum amount each family member pays for covered services in a year, contributing to the family's total out-of-pocket limit.`,
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'spaceField',
                type: 'space',
                isCustomField: false,
              },
            ],
            event: OPEN_DEDUCTIBLE_MODAL,
            isCustomizedDeductible: true,
          },
          {
            elements: [
              {
                type: 'header',
                fieldValue: 'SERVICES',
                isCustomField: true,
              },

              {
                fieldName: 'officeVisit',
                fieldValue: 'MEDICAL_SERVICES_Office Visit',
                serviceBenefitCode: 1,
                fieldDescription:
                  'Cost of an outpatient appointment to see a general health care provider, especially a family physician, internist, or pediatrician, usually as part of regular, non-emergency care. ',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'specialistVisit',
                fieldValue: 'MEDICAL_SERVICES_Specialist Visit',
                serviceBenefitCode: 2,
                fieldDescription:
                  'A specialist focuses on a specific area of medicine. Examples include dermatologists, cardiologists, psychiatrists, surgeons, etc. Some plan types require a referral from your primary care physician for the specialist visit to be covered.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'virtualCareVisit',
                fieldValue: 'MEDICAL_SERVICES_Virtual Care',
                serviceBenefitCode: 108,
                fieldDescription:
                  'Cost of an outpatient appointment to see a general health care provider, especially a family physician, internist, or pediatrician, usually as part of regular, non-emergency care. ',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'preventiveCare',
                fieldValue: 'MEDICAL_SERVICES_Preventive Care',
                serviceBenefitCode: 95,
                fieldDescription:
                  'Preventive care typically includes annual check-ups, flu shots, vaccinations, as well as certain tests and screenings.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'emergencyRoom',
                fieldValue: 'MEDICAL_SERVICES_Emergency Room',
                serviceBenefitCode: 15,
                fieldDescription:
                  "An emergency room provides treatment for an acute injury or illness that poses an immediate risk to a person's life or long-term health.",
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'urgentCare',
                fieldValue: 'MEDICAL_SERVICES_Urgent Care',
                serviceBenefitCode: 13,
                fieldDescription:
                  'Urgent care centers are specific medical facilities where you can receive same-day treatment for urgent, but non-life-threatening conditions.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'coInsurance',
                fieldValue: 'MEDICAL_SERVICES_Coinsurance',
                serviceBenefitCode: 107,
                fieldDescription:
                  'The percentage you pay for covered services after meeting your deductible. Example, if your co-insurance is 20% , then you pay 20%, your plan pays 80% of the cost.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'labXray',
                fieldValue: 'MEDICAL_SERVICES_Diagnostic Lab/ X-Ray',
                serviceBenefitCode: 77,
                fieldDescription:
                  'Services for certain laboratory tests and x-rays.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'complexImaging',
                fieldValue: 'MEDICAL_SERVICES_Complex Imaging',
                serviceBenefitCode: 37,
                fieldDescription:
                  'Services for advanced imaging, including CT, PET, or MRI scans.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'inpatient',
                fieldValue: 'MEDICAL_SERVICES_Hospital Inpatient',
                serviceBenefitCode: 87,
                fieldDescription:
                  'The cost associated with being admitted to the hospital to receive inpatient services. The expectation is the patient will occupy a bed and remain at least overnight.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'outPatient',
                fieldValue: 'MEDICAL_SERVICES_Hospital Outpatient',
                serviceBenefitCode: 88,
                fieldDescription:
                  'The cost associated with outpatient services. The expectation is the patient will not be admitted to the hospital overnight.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'chiropracticCare',
                fieldValue: 'MEDICAL_SERVICES_Chiropractic Care',
                serviceBenefitCode: 34,
                fieldDescription:
                  'Chiropractic care is covered under most health insurance plans. Some plans may have visit limits, dollar limits or referral requirements.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'acupuncture',
                fieldValue: 'MEDICAL_SERVICES_Acupuncture Care',
                serviceBenefitCode: 40,
                fieldDescription:
                  'Some health plans cover acupuncture when it is medically necessary and prescribed by your doctor.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                additionalServices: 'true',
              },
            ],
            event: OPEN_SERVICE_MODAL,
            isCustomizedServices: true,
          },
          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'RX',
              },
              {
                fieldName: 'rxDeductibles',
                fieldValue: 'MEDICAL_RX_Individual Deductible',
                fieldSpecialization: 'individual',
                fieldDescription:
                  'Rx deductible is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered prescription medications.',
                fieldFormatter: 'customServiceFormatter',
                alwaysShowTitle: true,
              },
              {
                fieldName: 'rxDeductibles',
                fieldValue: 'MEDICAL_RX_Family Deductible',
                fieldSpecialization: 'family',
                fieldDescription:
                  'Rx deductible is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered prescription medications.',
                fieldFormatter: 'customServiceFormatter',
                alwaysShowTitle: true,
              },
              {
                fieldName: 'rxOOP',
                fieldValue: 'MEDICAL_RX_Individual Out-of-Pocket Max',
                showTitleIfExists: true,
                fieldSpecialization: 'individual',
                fieldDescription:
                  'The most you have to pay for covered prescription medications in a plan year.',
                fieldFormatter: 'customServiceFormatter',
              },
              {
                fieldName: 'rxOOP',
                fieldValue: 'MEDICAL_RX_Family Out-of-Pocket Max',
                showTitleIfExists: true,
                fieldSpecialization: 'family',
                fieldDescription:
                  'The most you have to pay for covered prescription medications in a plan year.',
                fieldFormatter: 'customServiceFormatter',
              },

              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 1',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_1',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 2',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_2',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 3',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_3',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 4',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_4',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 5',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_5',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 6',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_6',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 7',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_7',
              },
              {
                fieldName: 'rxCost',
                fieldValue: 'MEDICAL_RX_Retail Tier 8',
                showTitleIfExists: true,
                fieldFormatter: 'customServiceFormatter',
                rxCode: 'TIER_8',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 1',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_1',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 2',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_2',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 3',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_3',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 4',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_4',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 5',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_5',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 6',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_6',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 7',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_7',
              },
              {
                fieldName: 'mailRxCost',
                fieldValue: 'MEDICAL_RX_Mail Order Tier 8',
                fieldDescription:
                  "Using your carrier's mail order pharmacy may save you time and money.For details, check your carrier's Summary of Benefits and Coverage (SBC).",
                fieldFormatter: 'customServiceFormatter',
                showTitleIfExists: true,
                rxCode: 'TIER_8',
              },
            ],
            event: OPEN_RX_MODAL,
            isCustomizedRX: true,
          },
        ],
      },
      {
        planType: 'dental',
        hotspots: [
          {
            elements: [
              {
                fieldName: 'title',
                fieldValue: 'Plan Name',
                fieldQueries: ['$.name'],
              },
            ],
            event: OPEN_BASIC_INFO_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'monthlyCost',
                fieldValue: 'Your Monthly Cost',
                fieldFormatter: 'contributionFormatter',
                defaultValue: '',
              },
              {
                fieldName: 'planNetwork',
                fieldValue: 'Plan Network',
                fieldFormatter: '',
                defaultValue: 'Select Open Access Plans',
              },
            ],
            event: OPEN_RATES_MODAL,
            isPlanNetworkIncluded: true,
          },
          {
            elements: [
              {
                fieldName: 'customFields',
                fieldValue: '+ Manage Custom Row',
                fieldFormatter: '',
                defaultValue: '',
                customHeader: true,
              },
              {
                fieldName: 'spaceField',
                type: 'space',
                isCustomField: true,
              },
            ],
            isSeparateRowEvent: true,
            event: OPEN_CUSTOM_ROW_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'DEDUCTIBLES & BENEFIT MAXIMUMS',
              },
              {
                fieldName: 'calendarYearMax',
                fieldValue: 'DENTAL_DEDUCTIBLE_Annual Maximum (Per Person)',
                fieldDescription:
                  'This is the maximum dollar amount a dental benefit plan will pay toward the cost of dental care within a the plan year. The patient is personally responsible for paying costs above the annual maximum.',
                fieldFormatter: 'calenderYearMaxFormatter',
              },
              {
                fieldName: 'deductibleCost',
                fieldValue: 'DENTAL_DEDUCTIBLE_Individual Deductible',
                fieldSpecialization: 'individual',
                fieldDescription:
                  'This is a fixed amount you pay out-of-pocket before insurance starts to share the cost of covered expenses.',
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'deductibleCost',
                fieldValue: 'DENTAL_DEDUCTIBLE_Family Deductible',
                fieldSpecialization: 'family',
                fieldDescription: '',
                fieldFormatter: 'coverageFormatter',
              },
              {
                fieldName: 'orthodontiaLifetimeMax',
                fieldValue: 'DENTAL_DEDUCTIBLE_Orthodontia Maximum',
                fieldDescription:
                  'Orthodontic coverage typically involves a Lifetime Maximum (LTM) benefit. This is the most money the dental plan will pay for dental care for the employee (or family) for the life of the plan.',
                fieldFilter: ['$.orthodontiaLifetimeMax'],
                fieldFormatter: 'coverageFormatter',
              },
            ],
            event: OPEN_DEDUCTIBLE_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'SERVICES',
              },
              {
                fieldName: 'preventive',
                fieldValue: 'DENTAL_SERVICES_Preventive Care',
                fieldDescription:
                  'Preventive services are associated with the prevention of disease through educational and protective measures (such as routine office visits, cleanings, check-ups, etc). Diagnostic may include x-rays, bitewing, full-mouth, or intraoral occlusal film.',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 38,
              },
              {
                fieldName: 'routineDentalService',
                fieldValue: 'DENTAL_SERVICES_Routine Dental Service',
                fieldDescription: '',
                fieldFilter: [
                  '$.customServices[?(@.benefitCode.code== 8)].serviceValue.:networkCamelCase',
                ],
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 8,
                showTitleIfExists: true,
              },
              {
                fieldName: 'dentalCheckUpChild',
                fieldValue: 'DENTAL_SERVICES_Dental Check-up (Children)',
                fieldDescription: '',
                fieldFilter: [
                  '$.customServices[?(@.benefitCode.code==44)].serviceValue.:networkCamelCase',
                ],
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 44,
                showTitleIfExists: true,
              },
              {
                fieldName: 'basicDentalCare',
                fieldValue: 'DENTAL_SERVICES_Basic Care',
                fieldDescription:
                  'Procedures to repair and restore individual teeth due to decay, trauma, impaired function, attrition, abrasion, erosion, etc.',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 53,
              },
              {
                fieldName: 'basicDentalCareChild',
                fieldValue: 'DENTAL_SERVICES_Basic Dental Care (Child)',
                fieldDescription:
                  'Procedures to repair and restore individual teeth due to decay, trauma, impaired function, attrition, abrasion, erosion, etc.',
                fieldFilter: [
                  '$.customServices[?(@.benefitCode.code==50)].serviceValue.:networkCamelCase',
                ],
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 50,
                showTitleIfExists: true,
              },

              {
                fieldName: 'majorDentalCare',
                fieldValue: 'DENTAL_SERVICES_Major Care',
                fieldDescription:
                  'Procedures dealing with the restoration of teeth. This could include inlays, crowns, veneers, bridges, root canals, oral surgery, etc.',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 55,
              },
              {
                fieldName: 'endodonticCare',
                fieldValue: 'DENTAL_SERVICES_Endodontic Care',
                fieldDescription: 'Endodontic care',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 99,
              },
              {
                fieldName: 'periodonticCare',
                fieldValue: 'DENTAL_SERVICES_Periodontic Care',
                fieldDescription: 'Periodontic care',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 100,
              },
              {
                fieldName: 'waitingPeriod',
                fieldValue: 'DENTAL_SERVICES_Waiting Period',
                fieldDescription: 'Waiting period',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 98,
              },
              {
                fieldName: 'implants',
                fieldValue: 'DENTAL_SERVICES_Implants',
                fieldDescription: 'Implants',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 101,
              },
              {
                fieldName: 'outOfNetworkReimbursement',
                fieldValue: 'DENTAL_SERVICES_Out-of-Network Reimbursement',
                fieldDescription: 'Out of network reimbursement',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 97,
                availableOnly: 'OUT',
              },
              {
                additionalServices: 'true',
              },
            ],
            event: OPEN_SERVICE_MODAL,
            isCustomizedServices: true,
          },
          {
            elements: [],
            event: OPEN_DEDUCTIBLE_MODAL,
          },
        ],
      },
      {
        planType: 'vision',
        hotspots: [
          {
            elements: [
              {
                fieldName: 'title',
                fieldValue: 'Plan Name',
                fieldQueries: ['$.name'],
              },
            ],
            event: OPEN_BASIC_INFO_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'monthlyCost',
                fieldValue: 'Your Monthly Cost',
                fieldFormatter: 'contributionFormatter',
                defaultValue: '',
              },
              {
                fieldName: 'planNetwork',
                fieldValue: 'Plan Network',
                fieldFormatter: '',
                defaultValue: 'Select Open Access Plans',
              },
            ],
            event: OPEN_RATES_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'customFields',
                fieldValue: '+ Manage Custom Row',
                fieldFormatter: '',
                defaultValue: '',
                customHeader: true,
              },
              {
                fieldName: 'spaceField',
                type: 'space',
                isCustomField: true,
              },
            ],
            isSeparateRowEvent: true,
            event: OPEN_CUSTOM_ROW_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'FREQUENCIES',
              },
              {
                fieldName: 'eyeExam',
                fieldValue: 'VISION_FREQUENCY_Eye Exam Frequency',
                fieldDescription: 'Eye exam',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 102,
                availableOnly: 'IN', // UAT-519 changes to hide frequency for OON
              },
              {
                fieldName: 'lenses',
                fieldValue: 'VISION_FREQUENCY_Lenses Frequency',
                fieldDescription: 'Lenses',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 103,
                availableOnly: 'IN', // UAT-519 changes to hide frequency for OON
              },
              {
                fieldName: 'frames',
                fieldValue: 'VISION_FREQUENCY_Frames Frequency',
                fieldDescription: 'Frames',
                fieldContext: 'frequency',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 104,
                availableOnly: 'IN', // UAT-519 changes to hide frequency for OON
              },
            ],
            event: OPEN_FREQUENCIES_MODAL,
          },
          {
            elements: [
              {
                fieldName: 'header',
                type: 'header',
                fieldValue: 'SERVICES',
              },
              {
                fieldName: 'exam',
                fieldValue: 'VISION_SERVICES_Exam Copay',
                fieldDescription:
                  'A standard eye exam involves a series of tests to evaluate your vision and check for eye diseases.',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 12,
              },
              {
                fieldName: 'materialsCopay',
                fieldValue: 'VISION_SERVICES_Materials Copay',
                fieldDescription: 'Materials copay',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 109,
              },
              {
                fieldName: 'eyeGlassLensesSingle',
                fieldValue: 'VISION_SERVICES_Eyeglass Lenses Single',
                fieldDescription: 'Eyeglass lenses single',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 72,
              },
              {
                fieldName: 'eyeGlassLensesBifocal',
                fieldValue: 'VISION_SERVICES_Eyeglass Lenses Bifocal',
                fieldDescription: 'Eyeglass lenses bifocal',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 73,
              },
              {
                fieldName: 'eyeGlassLensesTrifocal',
                fieldValue: 'VISION_SERVICES_Eyeglass Lenses Trifocal',
                fieldDescription: 'Eyeglass lenses trifocal',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 74,
              },

              {
                fieldName: 'eyeGlassLensesLenticular',
                fieldValue: 'VISION_SERVICES_Eyeglass Lenses Lenticular',
                fieldDescription: 'Eyeglass lenses lenticular',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 110,
              },
              {
                fieldName: 'frames',
                fieldValue: 'VISION_SERVICES_Frames',
                fieldDescription: 'Frames',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 71,
              },
              {
                fieldName: 'electiveContacts',
                fieldValue: 'VISION_SERVICES_Elective Contacts',
                fieldDescription: 'Elective contacts',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 75,
              },
              {
                fieldName: 'medicallyNeccessaryContacts',
                fieldValue: 'VISION_SERVICES_Medically Necessary Contacts',
                fieldDescription: 'Medically necessary contacts',
                fieldFormatter: 'customServiceFormatter',
                serviceBenefitCode: 76,
              },
              {
                additionalServices: 'true',
              },
            ],
            event: OPEN_SERVICE_MODAL,
            isCustomizedServices: true,
          },
        ],
      },
    ],
  },
};

export default meta;
